import { render, staticRenderFns } from "./rezervasyonlistesi.vue?vue&type=template&id=4ab7cca2&scoped=true"
import script from "./rezervasyonlistesi.vue?vue&type=script&lang=js"
export * from "./rezervasyonlistesi.vue?vue&type=script&lang=js"
import style0 from "./rezervasyonlistesi.vue?vue&type=style&index=0&id=4ab7cca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7cca2",
  null
  
)

export default component.exports